import React from 'react';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const TermsInJapan = () => (
  <div className="legal">
    <Head>
      <title>利用規約 | オンライン英会話のリンガルボックス</title>
    </Head>
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
      <div className="mt-12 mb-24 text-wrap">
        <h1>サービス利用規約</h1>
        <p className="mb-8">最終更新日: 2013年2月14日</p>
        <p>
          LingualBox,
          Inc（以下「当社」といいます）は、当社が運営する「LingualBox(リンガルボックス)」上で
          提供する全てのサービス（以下、「本サービス」）を本サービスの申し込み希望者及び利用者
          （以下「利用者」といいます）が利用することに関して以下の利用規約（以下「規約」といいます）
          を定めております。
          利用者は本サービスの利用をもって規約を承諾したものとみなします。
          また、利用者が未成年の場合は親権者等法定代理人の同意を得ることが必要になります。
        </p>
        <h3 className="mb-4 mt-8">第1条（利用規約の範囲及び変更）</h3>
        <p>
          1　利用規約の範囲は、当社のウェブサイト（以下、「本サイト」）に規定するものに加えて、
          当社が利用者に対して電子メール等で発信する情報も含めます。
        </p>
        <p>
          2　当社は利用者の承諾を得ることなく規約の改定、変更、新たな規定の追加ができるものとします。
          変更後の規約は、本サイトに掲載した時から効力を生じるものとし、利用者はその効力をあらかじめ承諾するものとします。
        </p>
        <h3 className="mb-4 mt-8">第2条（本サービスへの登録）</h3>
        <p>
          1　利用者は当社が定める手続きに従って、本サービスの登録をします。
          利用者は本サービスの登録にあたり、
          下記の事項を確認し、了承したものとします。
        </p>
        <p>
          （1）規約を熟読し、その内容を承諾した上で、本サービスに登録すること。
        </p>
        <p>
          （2）氏名、メールアドレス等の項目を真実かつ正確に登録し、その情報を利用者の責任で厳重に保管すること。
        </p>
        <p>（3）スカイプをインストールすること。</p>
        <p>
          （4）利用者の通信環境が本サービスの利用に支障がないことを確認すること。
        </p>
        <p>（5）当社が定める決済方法により利用料金を支払うこと。</p>
        <p>
          2　利用者による本サービスの登録は、当社の電子メールによる承諾の通知をもって完了するものとします。
          ただし、当社は利用者の代金の支払を当社が確認するまで本サービスの利用を制限できるものとします。
        </p>
        <h3 className="mb-4 mt-8">第3条（登録情報の変更）</h3>
        <p>
          利用者は当社に届けた登録情報の内容に変更があった場合、
          遅滞なく本サイトにて登録情報の変更手続きを するものとします。
          利用者が登録情報の変更を怠ったことにより生じた利用者の不利益、
          その他の負担に関して、当社は一切の責任を負わないものとします。
        </p>
        <h3 className="mb-4 mt-8">第4条（登録情報の利用と取り扱い）</h3>
        <p>
          1　当社は利用者の登録情報を当社が別途掲載する「プライバシーポリシー」に則って適切に取り扱うものとします。
        </p>
        <p>
          2　利用者は登録した情報を厳重に管理・保管するものとします。当社は、本サイトにてIDおよびパスワードの一致を確認することにより、
          当該アクセス者を利用者本人とみなします。利用者による登録情報の失念、消失および登録情報の管理の不徹底による損害の責任は利用者が
          負うものとし、当社は一切の責任を負いません。また利用者は自己の登録情報が他者によって不正利用されていることを知った場合は、
          ただちに当社にその旨を連絡し、当社の指示に従うものとします。
        </p>
        <h3 className="mb-4 mt-8">第5条（サービス規定）</h3>
        <p>
          1　本サービスは、インターネットと弊社の指定するソフトを使用し、英会話レッスンを行うものです。本サービスの利用にあたっては、
          ヘッドセットが必要です。ヘッドセットは会員各自が用意するものとします。また、WEBカメラや市販の教材を使ったレッスンをご希望の
          場合（任意）についても、会員各自が用意するものとします。
        </p>
        <p>
          2　利用者は当社が別途定める1ヶ月分の利用料金をクレジットカードで支払うことで、本サービスを選択頂いたプランの利用回数内及び
          期間内で、自らレッスンの予約を行い、レッスンを受講することができます。
        </p>
        <p>
          3　利用者が第5条（2）による支払いを行った後、有効期間満了日の3営業日前までに第7条に定める退会手続きを行わない場合は、
          本サービスの利用を継続する意思があるものとみなし、支払い日から1ヵ月後の有効期間満了日に同料金にて継続的にユーザー登録が
          更新されるものとします。
        </p>
        <p>
          4　前項の規定にかかわらず、下記の場合は利用料金返還期間として利用料金を下記のように返金いたします。
        </p>
        <p>
          利用者が本サービスの利用料金を第5条2に定める方法で支払った後、当社が電子メールにて利用者の支払いを確認した旨を連絡した日付から
          起算して8日以内に第7条の定めにより退会の意思表示を行い、かつ、返金依頼の意思表示を行った場合は、利用料金から返金手数料壱千円を
          差し引いた金額を返金いたします。ただし、同一のクレジットカード、または、同一のIDで二回以上入会された場合は、8日以内に解約されても
          返金いたしません。
        </p>
        <p>
          5　当社は、利用者への一貫性のあるサービスを提供するために、レッスンで得られた情報を記録します。
        </p>
        <p>
          6　前項で得られた情報には利用者の個人情報が含まれる場合があります。
        </p>
        <p>7　当社が5で得た情報は、利用者へのサービス提供のみに用います。</p>
        <p>
          8　当社は、円滑なサービス提供のため、提供するサービスの監視を行うことがあります。
          利用者は自身が参加するレッスンを、当社によって
          監視されている可能性があることに予め同意し了承するものとします。
        </p>
        <p>
          9　当社は、フィリピンの祝祭日(ホーリーウィーク、クリスマス等)、年末年始、または研修等により休講日を定めます。また、利用者への
          事前告知なしに本サイトへの告知をもって、本サービスの休講日を変更できるものとします。
        </p>
        <p>10　レッスンの予約、キャンセルについて</p>
        <p>
          （1）予約はレッスン開始1時間前まで可能です。キャンセルは1時間前まで可能で、レッスン開始前60分以降はキャンセルできすに欠席扱いとなります。
        </p>
        <p>
          （2）利用者の遅刻、パソコンの不調など、利用者側の理由により開始が遅れた場合、レッスン開始時刻から10分間は講師が待機しております。
          10分経過した場合、欠席扱いとなります。
        </p>
        <p>
          11　予約した講師が事情によりレッスンできない場合、レッスン開始前であれば、代講の講師を振り分けます。
          また、代講の講師を振り分けられない 場合はチケットを返却致します。
        </p>
        <p>
          12　レッスン開始後、講師側個別の事情（通信環境の障害や体調不良等）により本サービスの利用が困難であった場合には、レッスン分のチケットを
          返却致します。
        </p>
        <p>
          13　講師個別の問題に起因しない理由（フィリピン全土または一部地域での政情、自然災害、通信障害等）で受講ができなくなった場合は、
          振替レッスンの発行対象にはなりませんので、あらかじめご了承ください。
        </p>
        <h3 className="mb-4 mt-8">第6条（禁止行為）</h3>
        <p>
          1　利用者は、本サービスの利用に際して、以下に定める行為、またはそのおそれがある行為を行ってはなりません。
        </p>
        <p>
          （1）利用者が本サービスを利用する権利を他者に譲渡、使用、売買すること。
        </p>
        <p>（2）本サービスまたは当社の名誉、信用を失墜・毀損させる行為。</p>
        <p>（3）違法行為、公序良俗に反する行為。</p>
        <p>（4）虚偽の情報を登録する行為。</p>
        <p>（5）本サービスの運用を妨げる行為。</p>
        <p>
          （6）本サービスに関連して営利を目的とする行為、およびその準備に利用する行為。
        </p>
        <p>（7）他の会員または当社若しくは第三者に不利益、損害を与える行為。</p>
        <p>（8）犯罪行為および犯罪行為に結びつく行為。</p>
        <p>
          （9）講師への嫌がらせや、不良行為、レッスンの進行を妨げる等のハラスメント行為。なお、ハラスメント行為の認定は、事実確認を行った上で、
          当社の判断により行います。
        </p>
        <p>
          （10）講師の雇用条件やコールセンターの場所、インターネット回線など当社が一般的に開示していない機密情報を詮索する行為。
        </p>
        <p>
          （11）電子メールの送受信を含め、オンライン、オフラインを問わず、利用者またはその代理人が講師と個人的に接触しようとする行為。
        </p>
        <p>
          （12）講師に当社の競合たりうるサービス・企業での勤務を勧誘する行為。
        </p>
        <p>
          （13）カスタマーサポートスタッフへの暴言、またはカスタマーサポート業務を妨げる行為。
        </p>
        <p>（14）ひとつのアカウントを複数人で利用する行為。</p>
        <p>（15）その他、当社が不適当と判断する行為。</p>
        <p>
          （16）利用者が前項に定める行為を行った場合、当社は利用者の登録を取り消すと共に、当社が何らかの損害を被った場合は、
          損害賠償、その他法的処置をとります。
        </p>
        <h3 className="mb-4 mt-8">第7条（退会）</h3>
        <p>
          利用者は退会手続きを所定の方法により行えます。利用者は本サイトの退会手続きページにて、ログイン後退会確認画面にて「退会する」
          ボタンをクリックした時点で退会手続きが完了するものとします。
        </p>
        <h3 className="mb-4 mt-8">第8条（登録の拒否・取り消し）</h3>
        <p>
          当社は、利用者が下記事由に該当する場合には、その登録を拒否し、もしくは登録を取消すことができます。また、支払いを済ませた金額は
          一切返金しないこととします。
        </p>
        <p>（1）利用者が実在しない場合。</p>
        <p>（2）利用者の登録情報に、虚偽、誤記または記入漏れがある場合。</p>
        <p>（3）利用者が既に本サービスに登録している場合。</p>
        <p>（4）利用者が過去に当社により登録の承認を取り消されている場合。</p>
        <p>（5）利用者に利用料金の支払い能力がない場合。</p>
        <p>（6）利用者が過去に代金の支払いを怠っていた場合。</p>
        <p>（7）利用者が第6条に定める禁止行為を行った場合。</p>
        <p>（8）本サービスの円滑な運営を妨げる恐れがある場合。</p>
        <p>
          （9）上記以外の事由で当社が利用者による本サービスの利用を不適切と判断した場合。
        </p>
        <h3 className="mb-4 mt-8">第9条（サービスの中断・終了）</h3>
        <p>
          当社はサービスの中断もしくは終了を事前もしくは事後に本サイトもしくは電子メールでの通知をもって行います。また、以下の事由に起因する場合、
          本サービスの全部または一部を中断することができるものとします。
        </p>
        <p>
          （1）天災、火災、停電、その他の非常事態により本サービスの提供ができなくなった場合。
        </p>
        <p>
          （2）戦争、内乱、暴動、労働争議等により、本サービスの提供ができなくなった場合。
        </p>
        <p>3）その他、運営上当社が一時的に中断を必要とした場合。</p>
        <h3 className="mb-4 mt-8">第10条（情報配信）</h3>
        <p>
          当社は利用者に対して電子メールによる通知、広告およびアンケート等を実施できるものとします。
        </p>
        <h3 className="mb-4 mt-8">第11条（スカイプの利用）</h3>
        <p>
          当社はスカイプを用いてサービスの提供を行っております。スカイプの利用に際し、利用者は下記の内容について同意したものといたします。
        </p>
        <p>
          （1）利用者は通話ソフトウェアの機能及びその利用規約についてスカイプの規定するそれに従うこととします。
        </p>
        <p>
          （2）本サービスの利用前までに通話ソフトウェアをダウンロードし、その機能を確認することは利用者の責任とします。
        </p>
        <p>
          （3）通話ソフトウェア及びその利用に必要なハードウェアの故障、設定不備および不具合により、サービスが利用できない場合、
          当社は一切責任を負わないこととします。
        </p>
        <p>
          （4）スカイプのチャットなどを通じ、講師から送られてきたファイルやURLを開くときは、ユーザーの自己責任で開くものとします。
          送られてきたファイル・URLが原因となってウィルス感染などの損害が発生した場合でも、当社は一切責任を負わないこととします。
        </p>
        <p>
          （5）利用者が登録したスカイプ名は、レッスン提供を目的として講師に対して公開されます。利用者が登録したスカイプ名は、
          当社が別途規定するプライバシーポリシーに則り、適切に取り扱う個人情報には該当しないものとします。利用者はプライベートで使用するスカイプ名を
          公開したくない場合は、本サービスを受けるためのスカイプ名を作成し当社に登録するなど、自身の個人情報を保護・管理するにあたり合理的かつ必要な
          予防措置を講じることとします。
        </p>
        <p>
          （6）当社はスカイプの事情により生じたトラブルについては一切責任を負いません。
          またスカイプが提供するサービスに関するお問い合わせについては、
          一切受け付けておりません。
        </p>
        <h3 className="mb-4 mt-8">第12条（賠償責任の制限）</h3>
        <p>
          1　利用者は下記に定める事項に起因または関連して生じた一切の損害について、当社が賠償責任を負わないことに同意します。
        </p>
        <p>（1）本サービスを利用したこと、または利用ができなかったこと。</p>
        <p>
          （2）利用者の送信やデータへの不正アクセスや不正な改変がなされたこと。
        </p>
        <p>（3）本サービス中の第三者による発言、送信や行為。</p>
        <p>（4）本サービスの学習効果等。</p>
        <p>（5）利用者がレッスン中に伝えた情報に起因するあらゆる損害。</p>
        <p>
          （6）国内外の政治情勢・自然災害等、当社の責任によらない事由で本サービスを中断した場合。
        </p>
        <p>
          （7）以下の状況により、利用者が本サービスに対して満足な利用が出来なかった場合。
        </p>
        <p>
          a)急激な生徒様数の増加やフィリピン側の通信障害発生などによる提供可能レッスン数の急減により、提供レッスン数が一時的に不足している状況。
        </p>
        <p>b)希望する時間帯のレッスンが予約できない状況。</p>
        <p>c)特定の講師のレッスンが予約できない状況。</p>
        <p>
          d)フィリピンでの停電・通信障害発生などによりレッスンを中止せざるを得ない状況。
        </p>
        <p>
          2　本サービスに関する当社からの主な連絡手段は電子メールまたは本サイトとし、利用者は当社からの電子メールを受信して、
          または本サイトにて確認するものとします。利用者が確認を怠ったことにより生じる利用者の不利益には、当社は賠償する義務を一切負わないものとします。
        </p>
        <p>
          3　当社は、利用者が本サービス利用時にコンピュータウィルス感染等により発生した損害と、本サービスに使用するソフト、配信ファイルによって
          発生したいかなる損害も、賠償する義務を一切負わないものとします。
        </p>
        <h3 className="mb-4 mt-8">第13条（著作権および所有権）</h3>
        <p>
          本サービスに関する商標、ロゴマークおよび記載等についての著作権、所有権は全て当社に帰属します。
          これらを利用者が当社に無断で使用することを 禁じます。
        </p>
        <h3 className="mb-4 mt-8">
          第14条（準拠法および専属的合意管轄裁判所）
        </h3>
        <p>
          デラウェア州の抵触法を除き、本規約または本サービスに起因するまたは関連するいかなる紛争に関しても、アメリカ合衆国デラウェア州法律が
          適用されます。本規約または本サービスに起因するまたは関連するいかなる主張についても、アメリカ合衆国デラウェア州内に所在する裁判所に
          おいてのみ裁判手続を取ることができるものとし、ユーザーと LingualBox
          はその裁判所の対人管轄権に同意するものとします。
        </p>
      </div>
    </div>
  </div>
);

export const getStaticProps = async ({ locale = 'ja' }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common', 'terms'])),
  },
});

export default TermsInJapan;
